import * as React from 'react'
import { Collapse } from '@mui/material';


type Props = {
  className?: string
}

const TerminalChannelHeuristicsTable: React.FC<Props> = ({ className = '' }) => {

  const tableHeaderClasses = 'text-left pr-4 text-gray-700 font-normal text-xs uppercase py-2 pl-2 border-b bg-gray-100';
  const tableRowClasses = 'hover:bg-gray-100 border-b text-xs';
  const tableCellClasses = 'pr-4 pl-2 py-2 ';
  const criteriaCellClasses = 'text-gray-600';
  return (
    <div className={' ' + className}>

      <table className="w-full">
        <thead className="">
          <tr className="">
            <th className={tableHeaderClasses + ' rounded-tl'}>
              Channel heuristic
            </th>
            <th className={tableHeaderClasses}>
              Criteria
            </th>
            <th className={tableHeaderClasses + ' rounded-tr'}>
              Clarifications
            </th>
          </tr>
        </thead>

        <tbody>

          <tr className={tableRowClasses}>
            <td className={tableCellClasses}>
              Minimal age
            </td>
            <td className={tableCellClasses + ' ' + criteriaCellClasses}>
              1 week
            </td>
            <td className={tableCellClasses}>

            </td>
          </tr>
          {/* <tr className={tableRowClasses}>
            <td className={tableCellClasses}>
              Minimal capacity
            </td>
            <td className={tableCellClasses + ' ' + criteriaCellClasses}>
              2 million satoshi
            </td>
            <td className={tableCellClasses}>
              
            </td>
          </tr> */}
          <tr className={tableRowClasses}>
            <td className={tableCellClasses}>
              Minimal routable tokens
            </td>
            <td className={tableCellClasses + ' ' + criteriaCellClasses}>
              1 million satoshi
            </td>
            <td className={tableCellClasses + ' ' + criteriaCellClasses}>
              <div style={{ maxWidth: '400px' }}>
                <p>
                  1+ million satoshi of liquidity on at least one side over a long period of time.
                  Depending on which side the balance is, your channel is considered a good inbound or a good outbound channel.
                  
                </p>
                <p className="py-1">
                  Terminal measures this heuristic around once a week. This creates an update lag of acknowledged in/outbound peers.
                </p>
                *More research into this heuristic is needed.
              </div>

            </td>
          </tr>
          <tr className={tableRowClasses}>
            <td className={tableCellClasses}>
              Minimal uptime
            </td>
            <td className={tableCellClasses + ' ' + criteriaCellClasses}>
              99.9%
            </td>
            <td className={tableCellClasses + ' ' + criteriaCellClasses}>
              0.1% of a day is 1 minute and 26 seconds.
            </td>
          </tr>
          <tr className={tableRowClasses}>
            <td className={tableCellClasses}>
              Minimal channel capacity
            </td>
            <td className={tableCellClasses + ' ' + criteriaCellClasses}>
              1 to 2 million satoshi
            </td>
            <td className={tableCellClasses + ' ' + criteriaCellClasses}>

            </td>
          </tr>
        </tbody>

      </table>
    </div>
  );
}

export default TerminalChannelHeuristicsTable;

